import React from 'react';
import { Space, Typography } from 'antd';
import type { IERPUser } from '@admin-panel/types';
import { PORTAL_NAME } from '@admin-panel/config/env';
import AdminGeneralSettings from './AdminGeneralSettings';
import VendorGeneralSettings from './VendorGeneralSettings';
import WarehouseGeneralSettings from './WarehouseGeneralSettings';

type Props = {
  user?: IERPUser;
};

const isNexusSuperAdmin = (user?: IERPUser) =>
  Boolean(user?.roles?.some(role => role.name === 'NEXUS_SUPER_ADMIN'));

const GeneralSettingsContent: React.FC<Props> = ({ user }) => {
  const showVendorSettings = PORTAL_NAME === 'vendor' || isNexusSuperAdmin(user);

  return (
    <Space direction="vertical" size={16} style={{ width: '100%', padding: 0 }}>
      {PORTAL_NAME === 'admin' && <AdminGeneralSettings user={user} />}
      {PORTAL_NAME === 'warehouse' && <WarehouseGeneralSettings user={user} />}
      {showVendorSettings && <VendorGeneralSettings user={user} />}
      {PORTAL_NAME !== 'admin' &&
        PORTAL_NAME !== 'warehouse' &&
        PORTAL_NAME !== 'vendor' &&
        !showVendorSettings && (
          <Typography.Text type="secondary">No general settings available.</Typography.Text>
        )}
    </Space>
  );
};

export default GeneralSettingsContent;
